export { UserTypes }

let types = Object.freeze({
  DEFAULT: 'default',
  TEKS: 'teks'
})

function isValidUserType(usertype) {
  return Object.values(types).indexOf(usertype) > -1
}

function isUserTypeDefault(usertype) {
  return usertype === UserTypes.types.DEFAULT
}

function isUserTypeTeks(usertype) {
  return usertype === UserTypes.types.TEKS
}

const UserTypes = Object.freeze({
  types,
  checks: Object.freeze({
    isValidUserType,
    isUserTypeDefault,
    isUserTypeTeks
  })
})
